/**
 * Componente: DoctorApprovalStats
 * Exibe cards KPI para métricas de aprovação de médicos
 */

import { Users, TrendingUp, Clock } from 'lucide-react';

interface DoctorApprovalStatsProps {
  totalPending: number;
  newToday: number;
  avgReviewTime: string;
}

export function DoctorApprovalStats({
  totalPending,
  newToday,
  avgReviewTime,
}: DoctorApprovalStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Total Pending Card */}
      <div className="bg-white dark:bg-neutral-900 rounded-lg border border-gray-200 dark:border-neutral-800 p-6 shadow-sm">
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 font-medium mb-1">
              Total Pendente
            </p>
            <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
              {totalPending}
            </h3>
          </div>
          <div className="p-3 bg-teal-100 dark:bg-teal-900/30 rounded-lg">
            <Users className="w-5 h-5 text-teal-600 dark:text-teal-400" />
          </div>
        </div>
        <p className="text-xs text-teal-600 dark:text-teal-400 font-medium">
          Na fila agora
        </p>
      </div>

      {/* New Today Card */}
      <div className="bg-white dark:bg-neutral-900 rounded-lg border border-gray-200 dark:border-neutral-800 p-6 shadow-sm">
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 font-medium mb-1">
              Novos Hoje
            </p>
            <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
              {newToday}
            </h3>
          </div>
          <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
            <TrendingUp className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <p className="text-xs text-blue-600 dark:text-blue-400 font-medium">
          Pendentes criados hoje
        </p>
      </div>

      {/* Average Review Time Card */}
      <div className="bg-white dark:bg-neutral-900 rounded-lg border border-gray-200 dark:border-neutral-800 p-6 shadow-sm">
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 font-medium mb-1">
              Tempo Médio de Análise
            </p>
            <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
              {avgReviewTime}
            </h3>
          </div>
          <div className="p-3 bg-green-100 dark:bg-green-900/30 rounded-lg">
            <Clock className="w-5 h-5 text-green-600 dark:text-green-400" />
          </div>
        </div>
        <p className="text-xs text-green-600 dark:text-green-400 font-medium">
          Aprovados analisados
        </p>
      </div>
    </div>
  );
}
